import { render } from "./redLog.vue?vue&type=template&id=3035892a&scoped=true"
import script from "./redLog.vue?vue&type=script&lang=js"
export * from "./redLog.vue?vue&type=script&lang=js"

import "./redLog.vue?vue&type=style&index=0&id=3035892a&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3035892a"]])

export default __exports__